import React, { Component } from "react";
import srcIconLogo from "../styles/img/logo-kiuono-white.svg";
import { Redirect } from "react-router-dom";
import jwt_decode from "jwt-decode";
import { emptyToken } from "../modules/auth/Auth.ducks";
import { connect } from "react-redux";
import _ from "lodash";

const LogoLogin = () => (
  <object
    data={srcIconLogo}
    type="image/svg+xml"
    className="img-fluid logo-splash"
  />
);

class SplashScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirectAdmin: false,
      redirectEtat: false,
      redirectInconnu: false,
    };
  }
  componentDidMount() {
    let token = localStorage.getItem("token");
    let tokenDecoded = token ? jwt_decode(token) : "";
    let { abonnement, handleRedirect } = this.props;

    console.log("abonnement && abonnement.statut== active ", abonnement);
    console.log(" token ", token);
    console.log(" tokenDecoded ", tokenDecoded);

    if (
      abonnement &&
      (abonnement.statut === "ACTIVE" || abonnement.statut === "TRIALING")
    ) {
      console.log("abonnement && abonnement.statut== active ", abonnement);
      console.log(" token ", token);
      console.log(" tokenDecoded ", tokenDecoded);
      handleRedirect();
    }




    else if (
      abonnement &&
      tokenDecoded.TYPE_COMPTE !== "ADMIN_CRECHE" &&
      abonnement.statut !== "ACTIVE" && abonnement.statut !== "TRIALING"
    ) {
      console.log("abonnement case 2 comppppppppp", abonnement);
      this.setState({ redirectEtat: true });
    }
    else if (
      abonnement &&
      tokenDecoded.TYPE_COMPTE === "ADMIN_CRECHE" &&
      abonnement.statut !== "ACTIVE" && abonnement.statut !== "TRIALING"
    ) {
      console.log("abonnement case 3 comppppppppp", abonnement);
      this.setState({ redirectAdmin: true });
    }



    else if (
      abonnement &&
      tokenDecoded.TYPE_COMPTE === "ADMIN_CRECHE" &&
      ["ANNULE", "NON_ABONNEE"].includes(abonnement.statut)
    ) {
      console.log("abonnement case 4 comppppppppp", abonnement);
      this.setState({ redirectAdmin: true });
    } else if (
      abonnement &&
      tokenDecoded.TYPE_COMPTE === "ADMIN_CRECHE" &&
      abonnement.statut === "INCONNU"
    ) {
      console.log("abonnement case 5 comppppppppp", tokenDecoded);
      this.setState({ redirectInconnu: true });
    }
  }
  componentDidUpdate(prevProps) {
    let token = localStorage.getItem("token");
    let tokenDecoded = token ? jwt_decode(token) : "";
    let { abonnement, handleRedirect } = this.props;
    console.log("abonnement  upppppppppp", abonnement);
    console.log("tokenDecoded  upppppppppp", tokenDecoded);

    if (
      abonnement &&
      (abonnement.statut === "ACTIVE" || abonnement.statut === "TRIALING")
    ) {
      console.log("abonnement && abonnement.statut== active ", abonnement);
      console.log(" token ", token);
      console.log(" tokenDecoded ", tokenDecoded);
      handleRedirect();
    }




    else if (
      abonnement &&
      tokenDecoded.TYPE_COMPTE !== "ADMIN_CRECHE" &&
      abonnement.statut !== "ACTIVE" && abonnement.statut !== "TRIALING"
    ) {
      console.log("abonnement case 2 upppppppppp", abonnement);
      this.setState({ redirectEtat: true });
    }
    else if (
      abonnement &&
      tokenDecoded.TYPE_COMPTE === "ADMIN_CRECHE" &&
      abonnement.statut !== "ACTIVE" && abonnement.statut !== "TRIALING"
    ) {
      console.log("abonnement case 3 upppppppppp", abonnement);
      this.setState({ redirectAdmin: true });
    }
    else if (
      abonnement &&
      tokenDecoded.TYPE_COMPTE === "ADMIN_CRECHE" &&
      ["ANNULE", "NON_ABONNEE"].includes(abonnement.statut)
    ) {
      console.log("abonnement case 4 upppppppppp", abonnement);
      this.setState({ redirectAdmin: true });
    } else if (
      abonnement &&
      tokenDecoded.TYPE_COMPTE === "ADMIN_CRECHE" &&
      abonnement.statut === "INCONNU"
    ) {
      console.log("abonnement case 5 upppppppppp", tokenDecoded);
      this.setState({ redirectInconnu: true });
    }
  }
  render() {
    let { redirectEtat, redirectAdmin, redirectInconnu, redirectStatus, redirectLogin } = this.state;
    let { abonnement } = this.props;
    return (
      <div className="main-wrapper login-page">
        {redirectEtat ? (
          <Redirect
            to={{
              pathname: "/etat-abonnement",
              state: { abonnement: abonnement },
            }}
          />
        ) : (
          ""
        )}
        {redirectAdmin ? (
          <Redirect
            to={{
              pathname: "/etat-abonnement-admin",
              state: { abonnement: abonnement },
            }}
          />
        ) : (
          ""
        )}

        {redirectInconnu ? (
          <Redirect
            to={{
              pathname: "/abonnement-inconnu",
              state: { abonnement: abonnement },
            }}
          />
        ) : (
          ""
        )}
        <div className="container-login">
          <div className="entete-login">
            <LogoLogin />
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({});

const mapDispatchToProps = {
  emptyToken,
};

export default connect(mapStateToProps, mapDispatchToProps)(SplashScreen);
